import * as React from 'react'

const SvgSaveSeriesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={19} height={19} viewBox="0 0 19 19" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.475 9.438L10.3 6.717a1.25 1.25 0 00-.975-.468H1.5C.81 6.25.25 6.81.25 7.5v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-7.281c0-.284-.097-.56-.275-.781zM4.625 7.5h3.75v1.875h-3.75V7.5zm3.75 10h-3.75v-3.75h3.75v3.75zm1.25 0v-3.75c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v3.75H1.5v-10h1.875v1.875c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25v-1.5l1.875 2.344V17.5H9.625zm6.25-4.375h-1.25v-8.75h-8.75v-1.25h8.75c.69 0 1.25.56 1.25 1.25v8.75zM19 8.75h-1.25v-7.5h-7.5V0h7.5C18.44 0 19 .56 19 1.25v7.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgSaveSeriesIcon
